'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTranslate = require('@gandi/react-translate');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classname = require('classname');

var _classname2 = _interopRequireDefault(_classname);

require('./ItineraryPanel.css');

var _Itinerary = require('../Itinerary/Itinerary');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItineraryPanel = function (_Component) {
  (0, _inherits3.default)(ItineraryPanel, _Component);

  function ItineraryPanel() {
    (0, _classCallCheck3.default)(this, ItineraryPanel);
    return (0, _possibleConstructorReturn3.default)(this, (ItineraryPanel.__proto__ || (0, _getPrototypeOf2.default)(ItineraryPanel)).apply(this, arguments));
  }

  (0, _createClass3.default)(ItineraryPanel, [{
    key: 'close',
    value: function close(event) {
      event.preventDefault();
      this.props.closeCallback();
    }
  }, {
    key: 'onInit',
    value: function onInit(element) {
      if (element) {
        this.props.setPanel(element);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var __ = this.props.__;

      return _react2.default.createElement(
        'div',
        { className: (0, _classname2.default)('ItineraryPanel', { 'hidden-xs-up': !this.props.isOpen }), id: 'Print' },
        this.props.itinerary && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'ItineraryPanel__header' },
            _react2.default.createElement(
              'div',
              { className: 'ItineraryPanel__title' },
              __('Itinerary|Itinerary')
            ),
            _react2.default.createElement('a', { href: '#', className: 'ItineraryPanel__close icon-cross no-print', 'aria-label': __('Itinerary|Close dialog'), onClick: this.close.bind(this) })
          ),
          _react2.default.createElement(
            'div',
            { className: 'ItineraryPanel__address' },
            __('Itinerary|Departure'),
            ' : ',
            this.props.itinerary.startAddress
          ),
          _react2.default.createElement(
            'div',
            { className: 'ItineraryPanel__address' },
            __('Itinerary|Arrival'),
            ' : ',
            this.props.itinerary.endAddress
          ),
          _react2.default.createElement(
            'div',
            { className: 'ItineraryPanel__summary' },
            _react2.default.createElement('div', { className: (0, _classname2.default)('ItineraryPanel__summary-icon', _Itinerary.TRAVEL_MODES[this.props.travelMode]) }),
            _react2.default.createElement(
              'div',
              { className: 'ItineraryPanel__summary-text' },
              this.props.itinerary.duration,
              _react2.default.createElement(
                'span',
                { className: 'ItineraryPanel__distance' },
                '(',
                this.props.itinerary.distance,
                ')'
              )
            ),
            _react2.default.createElement('a', { href: '#', className: 'ItineraryPanel__summary-icon icon-printer no-print', 'aria-label': __('Itinerary|Print directions'), onClick: this.print.bind(this) })
          )
        ),
        _react2.default.createElement('div', { className: 'ItineraryPanel__itinerary print-overflow-visible', ref: this.onInit.bind(this) })
      );
    }
  }, {
    key: 'print',
    value: function print(event) {
      event.preventDefault();
      this.props.printCallback();
    }
  }]);
  return ItineraryPanel;
}(_react.Component);

ItineraryPanel.propTypes = {
  __: _propTypes2.default.func.isRequired, // @see https://github.com/Gandi/react-translate
  closeCallback: _propTypes2.default.func,
  isOpen: _propTypes2.default.bool,
  itinerary: _propTypes2.default.object,
  printCallback: _propTypes2.default.func,
  setPanel: _propTypes2.default.func,
  travelMode: _propTypes2.default.string
};

ItineraryPanel.defaultProps = {
  closeCallback: function closeCallback() {},
  isOpen: false,
  itinerary: null,
  printCallback: function printCallback() {},
  setPanel: function setPanel() {},
  travelMode: null
};

exports.default = (0, _reactTranslate.withTranslator)()(ItineraryPanel);


//////////////////
// WEBPACK FOOTER
// ./~/ui-kit/src/components/ItineraryPanel/ItineraryPanel.js
// module id = 1166
// module chunks = 0